<template>
  <div
    v-if="message.text && message.text.length > 0"
    :class="message.class"
    class="ui compact message">
    <p v-html="message.text"/>
  </div>
</template>

<script>
export default {
  name: 'Message',
  props: {
    message: {
      type: Object,
      required: true
    }
  }
}
</script>
